import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

// Custom colored social icons
const FacebookIcon = () => <svg viewBox="0 0 24 24" className="h-5 w-5" fill="#1877F2">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>;
const InstagramIcon = () => <svg viewBox="0 0 24 24" className="h-5 w-5">
    <defs>
      <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#FFDC80" />
        <stop offset="25%" stopColor="#F77737" />
        <stop offset="50%" stopColor="#E1306C" />
        <stop offset="75%" stopColor="#C13584" />
        <stop offset="100%" stopColor="#833AB4" />
      </linearGradient>
    </defs>
    <path fill="url(#instagram-gradient)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>;
const LinkedInIcon = () => <svg viewBox="0 0 24 24" className="h-5 w-5" fill="#0A66C2">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>;
const TikTokIcon = () => <svg viewBox="0 0 24 24" className="h-5 w-5">
    <path fill="#25F4EE" d="M9.472 10.539v-1.186A6.32 6.32 0 0 0 8.59 9.25a6.333 6.333 0 0 0-4.46 10.831A6.333 6.333 0 0 1 9.472 10.54z" />
    <path fill="#FE2C55" d="M9.68 18.367a3.568 3.568 0 0 0 3.563-3.36V2.47h3.112a5.474 5.474 0 0 1-.085-.97H12.48v12.535a3.569 3.569 0 0 1-3.563 3.361 3.54 3.54 0 0 1-1.658-.413 3.567 3.567 0 0 0 2.422.984z" />
    <path fill="#FE2C55" d="M19.205 6.392v-1.12a5.458 5.458 0 0 1-2.99-.888 5.495 5.495 0 0 0 2.99 2.008z" />
    <path fill="#25F4EE" d="M16.215 4.384a5.472 5.472 0 0 1-1.335-3.584h-1.11a5.497 5.497 0 0 0 2.445 3.584z" />
    <path fill="#25F4EE" d="M8.59 13.05a3.568 3.568 0 0 0-2.33 6.28 3.567 3.567 0 0 1 5.093-4.595v-4.196a6.392 6.392 0 0 0-.881-.103h-.209v3.011a3.553 3.553 0 0 0-1.673-.397z" />
    <path fill="#FE2C55" d="M19.205 6.392v3.012a9.236 9.236 0 0 1-5.425-1.742v7.92a6.333 6.333 0 0 1-9.65 5.399 6.333 6.333 0 0 0 11.522-3.599v-7.92a9.236 9.236 0 0 0 5.425 1.742V7.416a5.52 5.52 0 0 1-1.872-.624v-.4z" />
    <path fill="white" d="M13.78 15.582v-7.92a9.236 9.236 0 0 0 5.425 1.742V6.392a5.495 5.495 0 0 1-2.99-2.008 5.497 5.497 0 0 1-2.445-3.584H10.88v14.567a3.568 3.568 0 0 1-5.85 2.716 3.568 3.568 0 0 0 5.88-2.716V4.8h1.11c.02.332.057.653.085.97v9.812z" />
  </svg>;
const Footer = () => {
  return <footer className="bg-glass border-t border-border/30 mt-20">
      <div className="container mx-auto py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img src="/logo-normandy-drone.png" alt="Normandy Drone" className="h-12 w-12 rounded-full" />
              <span className="text-lg font-bold text-foreground">Normandy Drone</span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Démoussage et inspection de toiture par drone en Normandie (Seine-Maritime & Eure). Interventions rapides, sécurisées et sans échafaudage.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <p className="text-foreground font-semibold">Contact</p>
            <div className="space-y-3">
              <a href="tel:0760268944" className="flex items-center gap-3 text-muted-foreground hover:text-secondary transition-colors text-sm">
                <Phone className="h-4 w-4 text-secondary" />
                07 60 26 89 44
              </a>
              <a href="mailto:normandydrone76@gmail.com" className="flex items-center gap-3 text-muted-foreground hover:text-secondary transition-colors text-sm">
                <Mail className="h-4 w-4 text-secondary" />
                normandydrone76@gmail.com
              </a>
              <div className="flex items-center gap-3 text-muted-foreground text-sm">
                <MapPin className="h-4 w-4 text-secondary" />
                Rouen – Normandie (76)
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <p className="text-foreground font-semibold">Nos services</p>
            <div className="flex flex-col gap-2">
              <Link to="/services/demoussage" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Démoussage toiture
              </Link>
              <Link to="/services/demoussage-monuments" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Démoussage monuments
              </Link>
              <Link to="/services/inspection" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Inspection toiture
              </Link>
              <Link to="/services/inspection-batiments" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Inspection bâtiments
              </Link>
              <Link to="/services/nettoyage-bardage" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Nettoyage bardage
              </Link>
              <Link to="/services/cartographie-drone" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Cartographie drone
              </Link>
              <Link to="/services/nettoyage-hauteur" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Nettoyage en hauteur
              </Link>
              <Link to="/services/inspection-thermographique" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Inspection thermographique
              </Link>
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <p className="text-foreground font-semibold">Navigation</p>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Accueil
              </Link>
              <Link to="/zone-intervention" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Zone d'intervention
              </Link>
              <Link to="/faq" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                FAQ
              </Link>
              <Link to="/contact" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Contact
              </Link>
              <Link to="/mentions-legales" className="text-muted-foreground hover:text-secondary transition-colors text-sm">
                Mentions légales
              </Link>
            </div>
          </div>

          {/* Social */}
          <div className="space-y-4">
            <p className="text-foreground font-semibold">Suivez-nous</p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/profile.php?id=61569276410002" target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-lg glass-card flex items-center justify-center hover:scale-110 transition-transform" aria-label="Facebook">
                <FacebookIcon />
              </a>
              <a href="https://www.instagram.com/normandydrone76/" target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-lg glass-card flex items-center justify-center hover:scale-110 transition-transform" aria-label="Instagram">
                <InstagramIcon />
              </a>
              <a href="https://www.linkedin.com/in/normandy-drone-452019382/" target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-lg glass-card flex items-center justify-center hover:scale-110 transition-transform" aria-label="LinkedIn">
                <LinkedInIcon />
              </a>
              <a href="https://www.tiktok.com/@normandy.drone" target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-lg glass-card flex items-center justify-center hover:scale-110 transition-transform" aria-label="TikTok">
                <TikTokIcon />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/30 text-center text-muted-foreground text-sm space-y-2">
          <p>© 2025 Normandy Drone – Tous droits réservés.</p>
          <p>
            Site créé par{" "}
            <a target="_blank" rel="noopener noreferrer" className="text-primary-link hover:underline" href="https://www.createur-site-vitrine.fr/">
              Aerodrone multiservices
            </a>
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;